var map = {
	"./1200px-Logo_gifi_2020.png": 26447,
	"./Logo-Esquénio---branco.png": 11216,
	"./Logo-Esquénio---cores.png": 63251,
	"./Logo-Esquénio---negro.png": 45532,
	"./atlas.png": 2838,
	"./atlas.svg": 64122,
	"./conduril.png": 21349,
	"./conduril.svg": 54135,
	"./edirio.png": 24497,
	"./geonorte.png": 11386,
	"./geonorte.svg": 14044,
	"./ignoto_branco.png": 99565,
	"./logo_conversas-com-pnl-22-FB.jpg": 39142,
	"./logo_conversas-com-pnl-22-TRP.png": 46634,
	"./logo_pequeno_final.png": 85227,
	"./matchc_logo.png": 31231,
	"./mc_logo.png": 16289,
	"./quinta do javali.svg": 38927,
	"./quinta_javali.png": 36719,
	"./reportlake.jpg": 51060,
	"./reportlake.png": 3280,
	"./reportlake.svg": 81814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85387;